import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    search = '',
    state = -1,
    pi = 1,
    ps = 50,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.kpiAudit.getCurrentTasks, {
        search,
        state,
        pi,
        ps,
    }, options);
    if (error) return { error, status };
    return content || { rows: [], total: 0, pi, ps, pc: 0 };
};
